import './App.css';
import React from 'react'
import { Route, Routes, Navigate } from "react-router-dom"
import HomePage from './components/PageComponents/HomePage.jsx'
import TeamPage from './components/PageComponents/TeamPage.jsx'
import PageHeader from './components/PageComponents/PageHeader.jsx'
import PageFooter from './components/PageComponents/PageFooter.jsx'
import RestoApp from './components/PageComponents/RestoApp.jsx'
import VoiceChatPage from './components/PageComponents/VoiceChatPage.jsx';
import BeansPicker from './components/BeansPicker.js'
import TradingSimDashboard from './components/Atonathon3/TradingSimDashboard';
import WorkplaceSimDashboard from './components/Atonathon4/WorkplaceSimDashboard';
import MagicTimer from './components/MagicTimer.jsx';
import ClueBoard from './components/ClueSim/ClueBoard.jsx';
import ClueHost from './components/ClueSim/ClueHost.jsx';

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      <div>
        <Routes>
          <Route path='/' element={<Navigate to='/cm' replace />} />
          <Route path='/cm' element={
            <>
              <PageHeader />
              <HomePage />
              <PageFooter />
            </>
          } />
          <Route path='/cm/team' element={
            <>
              <PageHeader />
              <TeamPage />
              <PageFooter />
            </>
          } />
          <Route path="/mtg/davesdouble" element={<MagicTimer />} />
          <Route path="/trading-sim" element={<TradingSimDashboard />} />
          <Route path="/workplace-sim" element={<WorkplaceSimDashboard />} />
          <Route path="/clue" element={<ClueBoard />} />
          <Route path="/clue/host" element={<ClueHost />} />
          <Route path='/beans/picker' element={<BeansPicker />} />
          <Route path='/beans/resto_app' element={<RestoApp />} />
          <Route path='/at/vc' element={<VoiceChatPage />} />
          <Route path='*' element={<div>Hey look, nothing!</div>} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
